import { render, staticRenderFns } from "./DeskInfoManage.vue?vue&type=template&id=d94c8016&"
import script from "./DeskInfoManage.vue?vue&type=script&lang=js&"
export * from "./DeskInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./DeskInfoManage.vue?vue&type=style&index=0&id=d94c8016&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d94c8016')) {
      api.createRecord('d94c8016', component.options)
    } else {
      api.reload('d94c8016', component.options)
    }
    module.hot.accept("./DeskInfoManage.vue?vue&type=template&id=d94c8016&", function () {
      api.rerender('d94c8016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/deskinfo-manage/DeskInfoManage.vue"
export default component.exports